<template>
  <n-field-select v-bind="attrs" v-on="listeners" />
</template>

<script>
import BaseCompany from './BaseCompany';
import { getSelection } from '@/store';
import { filter } from 'lodash-es';

const SELECTION_NAME = 'company.group';
export default BaseCompany.extend({
  name: 'NsGroup',
  computed: {
    attrs() {
      return {
        label: 'group',
        options: this.options,
        ...this.$attrs,
      };
    },
    options() {
      return filter(getSelection(SELECTION_NAME), item => item.extra.$group === this.companyId);
    },
  },
});
</script>
